import { render, staticRenderFns } from "./BoxDataFormatter.vue?vue&type=template&id=1a2726eb&functional=true"
import script from "./BoxDataFormatter.vue?vue&type=script&lang=js"
export * from "./BoxDataFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports